export default "__VITE_ASSET__CnbI_aeV__"